<script>
import baseMixin from '@/mixins/baseMixin'
import { isNullOrEmptyArray } from '@/helpers/array-helpers'
import FileListItem from './file-list-item.vue'

export default {
  name: 'FileList',
  components: {
    FileListItem,
  },
  mixins: [baseMixin],
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    disableDownload: {
      type: Boolean,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    showNoFilesBlock: {
      type: Boolean,
    },
  },
  computed: {
    compFilesLabel() {
      return this.hideLabel ? '' : this.$t('files.filesHeading')
    },
    hasFiles() {
      return !isNullOrEmptyArray(this.files)
    },
  },
  methods: {
    viewFile(id) {
      this.$emit('viewFile', id)
    },
    removeFile(id) {
      this.$emit('removeFile', id)
    },
    isLastListItem(index) {
      return index < this.files.length - 1
    },
  },
}
</script>

<template>
  <section v-if="hasFiles">
    <article data-testid="file-list-label" :class="hideLabel ? '' : 'mb-4'">{{
      compFilesLabel
    }}</article>
    <v-list data-testid="file-list" two-line class="py-0">
      <section v-for="(file, index) in files" :key="file.id">
        <FileListItem
          :file="file"
          :read-only="readOnly"
          :disable-download="disableDownload"
          @viewFile="viewFile"
          @removeFile="removeFile"
        />
        <v-divider v-if="isLastListItem(index)" :key="index"></v-divider>
      </section>
    </v-list>
  </section>
  <section
    v-else-if="showNoFilesBlock"
    data-testid="file-list-no-files-box"
    class="file-list__no-files-box text-center grey--text d-flex justify-center align-center rounded-lg"
  >
    <article>{{ $t('files.noFilesUploadedText') }}</article>
  </section>
</template>

<style lang="scss">
.file-list__no-files-box {
  min-height: 300px;
  background: repeating-linear-gradient(
    135deg,
    #efefef,
    #efefef 15px,
    rgb(0 0 0 / 0%) 15px,
    rgb(0 0 0 / 0%) 25px
  );
}

.theme--dark {
  .file-list__no-files-box {
    background: repeating-linear-gradient(
      135deg,
      #1e1e1e,
      #1e1e1e 15px,
      rgb(0 0 0 / 0%) 15px,
      rgb(0 0 0 / 0%) 25px
    ) !important;
  }
}
</style>
